var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitalNetwork(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 64,
    viewBox: "0 0 101 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2891 62.9772V1.26758H61.0022V62.9772",
    stroke: "#B17912",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9813 12.7941H41V11.2481H43.9813V8.29346H45.5413V11.2481H48.5226V12.7941H45.5413V15.7488H43.9813V12.7941Z",
    fill: "#FFCE73",
    stroke: "#B17912",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4669 18.4515C48.0504 18.4515 50.9553 15.5726 50.9553 12.0212C50.9553 8.46979 48.0504 5.59082 44.4669 5.59082C40.8835 5.59082 37.9785 8.46979 37.9785 12.0212C37.9785 15.5726 40.8835 18.4515 44.4669 18.4515Z",
    stroke: "#B17912",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.002 29.2622H77.1161V62.9772",
    stroke: "#B17912",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2148 62.9772V29.2622H27.2885",
    stroke: "#B17912",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7768 45.1919H37.5V62.977H51.7768V45.1919Z",
    fill: "#FFCE73",
    stroke: "#B17912",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5768 25.5576H35.9551V29.2624H41.5768V25.5576Z",
    fill: "#FFCE73",
    stroke: "#B17912",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9831 25.5576H47.3613V29.2624H52.9831V25.5576Z",
    fill: "#FFCE73",
    stroke: "#B17912",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3756 34.2437H35.7539V37.9484H41.3756V34.2437Z",
    fill: "#FFCE73",
    stroke: "#B17912",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7799 34.2437H47.1582V37.9484H52.7799V34.2437Z",
    fill: "#FFCE73",
    stroke: "#B17912",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8314 45.2725C96.1252 45.2725 100.417 41.0194 100.417 35.773C100.417 30.5265 96.1252 26.2734 90.8314 26.2734C85.5376 26.2734 81.2461 30.5265 81.2461 35.773C81.2461 41.0194 85.5376 45.2725 90.8314 45.2725Z",
    fill: "#FFCE73",
    stroke: "#B17912",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.584 39.9183C91.3178 39.6034 92.0631 39.2713 92.82 38.9163C93.9755 38.3437 95.1311 37.8054 96.1884 37.25",
    stroke: "#B17912",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5254 34.3813C90.6294 43.9553 90.7315 53.5312 90.8316 63.1089",
    stroke: "#B17912",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4503 62.9771H89.8098H76.1166H60.8171H60.0025H51.8848",
    stroke: "#B17912",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6074 62.9771H27.2888H26.9132H11.2151H0.867188",
    stroke: "#B17912",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalNetwork);
export default __webpack_public_path__ + "static/media/HospitalNetwork.0f2f9567d313e1edea1cd8dc51ab2fea.svg";
export { ForwardRef as ReactComponent };